import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import RolesListTopbar from "../../features/manageSubAdmin/rolesTopbar";
import RolesList from "../../features/manageSubAdmin/rolesList";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const ManageSubadminRoles = () => {
 
  const navigate = useNavigate();
   const goBack = () => {
      navigate(-1); 
    };
  return (
    <MainContainer>
      <div className="main_title d_flex">
        <h1 className="back_arrow">      <IconButton onClick={() => goBack()}>
                {" "}
                <ArrowBackIcon />{" "}
              </IconButton> Manage Roles</h1>
    <div className="right_s">
        <RolesListTopbar />
    </div>
      </div>
      
      <div className="cards table_cards v2">
      
        <RolesList />
      </div>
    </MainContainer>
  );
};

export default ManageSubadminRoles;
